/**
 * Formato visual de números Analytics (es-CL):
 * miles con punto, decimales con coma.
 * @module-isolated analytics-format
 */

/**
 * @param {unknown} value
 * @param {{ maxFractionDigits?: number, minFractionDigits?: number }} [opts]
 * @returns {string|unknown}
 */
export function formatAnalyticsNumber(value, opts) {
  if (value == null || value === '') return value;
  if (typeof value === 'boolean') return value;

  let suffix = '';
  let raw = value;

  if (typeof value === 'string') {
    const t = value.trim();
    if (!t) return value;
    if (/[%]$/.test(t)) {
      suffix = '%';
      raw = t.slice(0, -1).trim().replace(',', '.');
    } else if (/^[+-]?\d{1,3}(\.\d{3})+(,\d+)?$/.test(t)) {
      // ya formateado es-CL
      return value;
    } else if (/^[+-]?\d+(\.\d+)?$/.test(t)) {
      raw = t;
    } else if (/^[+-]?\d+,\d+$/.test(t)) {
      raw = t.replace(',', '.');
    } else {
      return value;
    }
  }

  const n = typeof raw === 'number' ? raw : Number(raw);
  if (!Number.isFinite(n)) return value;

  const maxFrac = opts && opts.maxFractionDigits != null ? opts.maxFractionDigits : 2;
  const isInt = Math.abs(n - Math.round(n)) < 1e-9;
  const minFrac =
    opts && opts.minFractionDigits != null ? opts.minFractionDigits : isInt ? 0 : undefined;

  return (
    n.toLocaleString('es-CL', {
      minimumFractionDigits: minFrac,
      maximumFractionDigits: isInt ? Math.max(minFrac || 0, 0) : maxFrac
    }) + suffix
  );
}

/**
 * Celda de tabla: formatea si es número o columna right-aligned numérica.
 * @param {unknown} value
 * @param {{ align?: string, format?: string }} [col]
 */
export function formatAnalyticsCell(value, col) {
  if (value == null || value === '') return value;
  if (col && col.format === 'text') return value;
  if (typeof value === 'number') return formatAnalyticsNumber(value);
  if (col && col.align === 'right') return formatAnalyticsNumber(value);
  if (typeof value === 'string' && /^[+-]?\d+(\.\d+)?%?$/.test(value.trim())) {
    return formatAnalyticsNumber(value);
  }
  return value;
}
